import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class UnsubscribeService {

    constructor(private httpClient: HttpClient) {

    }

    unsubscribe(token: string, types: EmailType[]): Observable<any> {
        return this.httpClient.post("/rest/unsubscribe/" + token, types)
    }
}

export enum EmailType {
    Marketing = "Marketing",
    RoundSharing = "RoundSharing"
}
